const baseUrl = '/api/v2/users';
export default ($axios) => {
    return {
        list: () => {
            return $axios.get(baseUrl)
        },
        store: (params) => {
            return $axios.post(baseUrl, params)
        }
    };
};
